import { render, staticRenderFns } from "./sms-auth-modal.vue?vue&type=template&id=e7dede7c&"
import script from "./sms-auth-modal.vue?vue&type=script&lang=js&"
export * from "./sms-auth-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports